import { UserApi } from "@/api/user.api";

export default async function profileOrdersLoader() {
  const [orders] = await Promise.all([UserApi.getOrders()]);

  return { orders: orders.data.orders };
}
